var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui-form-field ui-form-field__input ui-form-field__textarea",
      class: _vm.rootClasses
    },
    [
      _c("label", [
        !_vm.hasFloatingLabel && _vm.$scopedSlots.label
          ? _c(
              "span",
              { staticClass: "ui-form-field--title-label" },
              [_vm._t("label")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ui-form-field--input-container",
            attrs: { "data-action-count": _vm.actionCount }
          },
          [
            _vm.hasFloatingLabel && _vm.$scopedSlots.label
              ? _c(
                  "span",
                  { staticClass: "ui-form-field--floating-label" },
                  [_vm._t("label")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "textarea",
              _vm._g(
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentValue,
                        expression: "currentValue"
                      }
                    ],
                    ref: "input",
                    staticClass: "ui-form-field--input",
                    domProps: { value: _vm.currentValue },
                    on: {
                      focus: _vm.onFocus,
                      blur: _vm.onBlur,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentValue = $event.target.value
                      }
                    }
                  },
                  "textarea",
                  _vm.$attrs,
                  false
                ),
                _vm.$listeners
              )
            ),
            _vm._v(" "),
            _c("ui-actions", [_vm._t("actions")], 2)
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._t("messages")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8057ae8a", { render: render, staticRenderFns: staticRenderFns })
  }
}